module.exports = __webpack_public_path__ + "img/symbol_9.c6f2cd65.png";